/* tslint:disable */
/* eslint-disable */
/**
 * Partner Suite Storefront API
 * This is the Partner Suite Storefront API.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: dev@trove.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 * The terminal result of a pipeline, normalized to a Trove-owned enum. UNKNOWN represents any unrecognized Bitbucket result. Omitted entirely while the pipeline is still running.
 * @export
 * @enum {string}
 */
export const PipelineResult = {
    Successful: 'SUCCESSFUL',
    Failed: 'FAILED',
    Error: 'ERROR',
    Stopped: 'STOPPED',
    Unknown: 'UNKNOWN'
};
/**
 * The run-state of a pipeline, normalized to a Trove-owned enum. UNKNOWN represents any Bitbucket state value we do not recognize, so the field always satisfies this schema.
 * @export
 * @enum {string}
 */
export const PipelineState = {
    Pending: 'PENDING',
    Building: 'BUILDING',
    InProgress: 'IN_PROGRESS',
    Paused: 'PAUSED',
    Halted: 'HALTED',
    Completed: 'COMPLETED',
    Stopped: 'STOPPED',
    Unknown: 'UNKNOWN'
};
export const TriggerPipelineRequestSelectorEnum = {
    BumpPartnerLiquidVersion: 'bump_partner_liquid_version',
    DeployPartnerToProd: 'deploy_partner_to_prod'
};
/**
 * StorefrontApi - axios parameter creator
 * @export
 */
export const StorefrontApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the health status of the service
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheck: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the run-state of a storefront theme deploy pipeline for a partner.
         * @summary Get pipeline status
         * @param {string} partnerCode The partner code.
         * @param {string} uuid The Bitbucket pipeline uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineStatus: (partnerCode_1, uuid_1, ...args_1) => __awaiter(this, [partnerCode_1, uuid_1, ...args_1], void 0, function* (partnerCode, uuid, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getPipelineStatus', 'partnerCode', partnerCode);
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPipelineStatus', 'uuid', uuid);
            const localVarPath = `/liquid/{partnerCode}/pipeline/{uuid}`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-trove-user-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the current storefront theme versions for a partner.
         * @summary Get theme versions
         * @param {string} partnerCode The partner code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeVersions: (partnerCode_1, ...args_1) => __awaiter(this, [partnerCode_1, ...args_1], void 0, function* (partnerCode, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getThemeVersions', 'partnerCode', partnerCode);
            const localVarPath = `/theme/{partnerCode}/versions`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-trove-user-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Triggers a storefront theme deploy pipeline for a partner.
         * @summary Trigger a theme deploy pipeline
         * @param {string} partnerCode The partner code.
         * @param {TriggerPipelineRequest} triggerPipelineRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLiquidPipeline: (partnerCode_1, triggerPipelineRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, triggerPipelineRequest_1, ...args_1], void 0, function* (partnerCode, triggerPipelineRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('triggerLiquidPipeline', 'partnerCode', partnerCode);
            // verify required parameter 'triggerPipelineRequest' is not null or undefined
            assertParamExists('triggerLiquidPipeline', 'triggerPipelineRequest', triggerPipelineRequest);
            const localVarPath = `/liquid/{partnerCode}/pipeline`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-trove-user-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(triggerPipelineRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StorefrontApi - functional programming interface
 * @export
 */
export const StorefrontApiFp = function (configuration) {
    const localVarAxiosParamCreator = StorefrontApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns the health status of the service
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHealthCheck(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StorefrontApi.getHealthCheck']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the run-state of a storefront theme deploy pipeline for a partner.
         * @summary Get pipeline status
         * @param {string} partnerCode The partner code.
         * @param {string} uuid The Bitbucket pipeline uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineStatus(partnerCode, uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPipelineStatus(partnerCode, uuid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StorefrontApi.getPipelineStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the current storefront theme versions for a partner.
         * @summary Get theme versions
         * @param {string} partnerCode The partner code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeVersions(partnerCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThemeVersions(partnerCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StorefrontApi.getThemeVersions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Triggers a storefront theme deploy pipeline for a partner.
         * @summary Trigger a theme deploy pipeline
         * @param {string} partnerCode The partner code.
         * @param {TriggerPipelineRequest} triggerPipelineRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLiquidPipeline(partnerCode, triggerPipelineRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.triggerLiquidPipeline(partnerCode, triggerPipelineRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StorefrontApi.triggerLiquidPipeline']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * StorefrontApi - factory interface
 * @export
 */
export const StorefrontApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StorefrontApiFp(configuration);
    return {
        /**
         * Returns the health status of the service
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheck(options) {
            return localVarFp.getHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the run-state of a storefront theme deploy pipeline for a partner.
         * @summary Get pipeline status
         * @param {string} partnerCode The partner code.
         * @param {string} uuid The Bitbucket pipeline uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineStatus(partnerCode, uuid, options) {
            return localVarFp.getPipelineStatus(partnerCode, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current storefront theme versions for a partner.
         * @summary Get theme versions
         * @param {string} partnerCode The partner code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeVersions(partnerCode, options) {
            return localVarFp.getThemeVersions(partnerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers a storefront theme deploy pipeline for a partner.
         * @summary Trigger a theme deploy pipeline
         * @param {string} partnerCode The partner code.
         * @param {TriggerPipelineRequest} triggerPipelineRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLiquidPipeline(partnerCode, triggerPipelineRequest, options) {
            return localVarFp.triggerLiquidPipeline(partnerCode, triggerPipelineRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StorefrontApi - object-oriented interface
 * @export
 * @class StorefrontApi
 * @extends {BaseAPI}
 */
export class StorefrontApi extends BaseAPI {
    /**
     * Returns the health status of the service
     * @summary Health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorefrontApi
     */
    getHealthCheck(options) {
        return StorefrontApiFp(this.configuration).getHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the run-state of a storefront theme deploy pipeline for a partner.
     * @summary Get pipeline status
     * @param {string} partnerCode The partner code.
     * @param {string} uuid The Bitbucket pipeline uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorefrontApi
     */
    getPipelineStatus(partnerCode, uuid, options) {
        return StorefrontApiFp(this.configuration).getPipelineStatus(partnerCode, uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the current storefront theme versions for a partner.
     * @summary Get theme versions
     * @param {string} partnerCode The partner code.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorefrontApi
     */
    getThemeVersions(partnerCode, options) {
        return StorefrontApiFp(this.configuration).getThemeVersions(partnerCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Triggers a storefront theme deploy pipeline for a partner.
     * @summary Trigger a theme deploy pipeline
     * @param {string} partnerCode The partner code.
     * @param {TriggerPipelineRequest} triggerPipelineRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorefrontApi
     */
    triggerLiquidPipeline(partnerCode, triggerPipelineRequest, options) {
        return StorefrontApiFp(this.configuration).triggerLiquidPipeline(partnerCode, triggerPipelineRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map